// The one name an item goes by, everywhere an item is named. In order:
//   1. the item name as the reader read it (with the brand when the receipt
//      printed one) — shown as read, never tidied
//   2. the kind detail ("ice cream cake")
//   3. the kind ("Junk food")
//   4. "Unlabeled item"
import { KIND_LABELS } from './kindGroups';

const text = (v) => (typeof v === 'string' && v.trim() ? v.trim() : null);

export function itemLabel(line) {
  return text(line?.itemName) || text(line?.kindDetail) || (line?.kind && KIND_LABELS[line.kind]) || 'Unlabeled item';
}
